function PersistentLoginService(Restangular) {
    this._api = Restangular.one('CheckPersistentLogin');
}

PersistentLoginService.prototype.getLoginStatus = function () {
    return this._api.get();
};

module.exports = PersistentLoginService;



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/login/persistent-login/persistent-login-service.js
 **/